import {browserNames} from 'definitions/constant'
import {useEffect, useState} from 'react'

export const useBrowserDetect = () => {
  const [browser, setBrowser] = useState<string | null>(null)

  useEffect(() => {
    const userAgent = navigator.userAgent
    if (userAgent.includes(browserNames.firefox)) {
      setBrowser(browserNames.firefox)
    } else if (userAgent.includes(browserNames.chrome)) {
      setBrowser(browserNames.chrome)
    } else if (userAgent.includes(browserNames.safari)) {
      setBrowser(browserNames.safari)
    } else if (
      userAgent.includes(browserNames.MSIE) ||
      userAgent.includes(browserNames.Trident)
    ) {
      setBrowser(browserNames.IE)
    } else {
      setBrowser('Unknown')
    }
  }, [])

  return browser
}
